/**
 * Created by marcfehr on 14.11.16.
 *
 * @file Contains GoogleData class, the class responsible for downloading
 * the data from Google Spreadsheets.
 */


import React from 'react';
import Tabletop from 'tabletop';
import CandidateRow from '../candidateRow/CandidateRow.component';

import Arrow from '../googleData/imgs/arrow.svg';

import {timeParse} from 'd3-time-format';
const deChLocale = require('json!de-ch-locale');

const timestampParser = timeParse('%d/%m/%Y/%H/%M');


//region import CSS
// Semantic UI
require('ta-semantic-ui/semantic/dist/components/grid.css');
require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/container.css');
require('ta-semantic-ui/semantic/dist/components/segment.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/image.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('ta-semantic-ui/semantic/dist/components/header.css');
//endregion

require('../googleData/css/googleData.css');

/**
 * Configuration: Categories correspond to column names that should be
 * exposed as selectable in the visualisation
 */
// let categories = require('json!./categories.json');

/**
 * Container component, responsible for downloading the data from Google
 * Spreadsheets and setting up the configuration environment.
 */
class GoogleData extends React.Component {

  // nestedList;

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      googleData: [],
      showDewtails: '',
      lastUpdate: '',
      lastUpdateTimestamp: ''
    };
  }

  render() {

    let tableRow = (v, i) => {

      return (

        <div className='cabinet-grid' key={`person-${i}`}>

          <CandidateRow data={v} dataKey={i} />

        </div>

      )

    }

    return (
      <div key='trump-header' className={`ui vertical segment low-padding-top ${ this.state.loading ? 'loading' : '' }`}
           style={{marginTop: '0px'}}>

        <span className='arrow-wrapper'><img src={Arrow} style={{width: '20px', height: 'auto'}}/> <span className='arrow-text'>Aufklappen für mehr Infos</span></span>

        <div className='ui vertical very fitted segment no-padding-top' style={{borderTop: 'none !important'}}>

          {
            this.state.googleData.map(tableRow)
          }

        </div>
      </div>
    )
  }

  /**
   * Called once, after the initial rendering. Since we only try and request the
   * Site Data object now, we have to make sure that the render() method
   * won't render anything without having the required properties of it's
   * children elements.
   */
  componentDidMount() {

    // Get all 12-App-Data from Google (Sheet:
    // 1cGCJ_bOhKXj3dToG-TcRRrQ2YtmqfeFnOGzDbIRrucE)
    // Test data:
    // 1gXAmojjxwJM4MH8kLkkAYkvjfg_Rg8S69U-OHkJj8lw
    //
    // Von Outliers bereinigte Tabelle
    // 1Nu9PrWsPQMAdmdd2uV9aU4HYPBZU6zUZYneE7WF93_I
    Tabletop.init({
        key: '1qUbLwt2aQqiE_Hy1bareWsMz98p1nle0114TQEpqAPc',
        callback: (googleData) => {

          // The keys of the first object
          // let keysInGoogleData = keys(googleData[0]);

          let recentUpdate = '';
          let actualTimestamp = '';

          for (let i = 0; i < googleData.length; i++) {
            let actualDate = googleData[i].Update.toString();
            let parsedActualDate = timestampParser(googleData[i].Update);
            let splittedDate = actualDate.split('/');

            let actual = {
              day: parseInt(splittedDate[0],10),
              month: parseInt(splittedDate[1],10) + 1,
              year: parseInt(splittedDate[2],10),
              hour: parseInt(splittedDate[3]),
              minute: parseInt(splittedDate[4])
            }

            let timeStamp = {
              day: splittedDate[0],
              month: splittedDate[1],
              year: splittedDate[2],
              hour: splittedDate[3],
              minute: splittedDate[4]
            }

            // String Date
            let newDate = `${actual.month  }/${  actual.day  }/${  actual.year  }/${  parseInt(actual.hour,10)  }:${  parseInt(actual.minute,10)}`;

            // Timestamp
            actualTimestamp = Date.parse(`${timeStamp.year}-${timeStamp.month}-${timeStamp.day}T${timeStamp.hour}:${timeStamp.minute}`);

            if (recentUpdate <= actualTimestamp) {
              recentUpdate = `am ${actual.day}.${actual.month}.${actual.year} um ${actual.hour}:${actual.minute} Uhr`;
              this.setState({
                lastUpdateTimestamp: actualTimestamp
              })
            }

          }



          let timestampNow = Date.now() + (60 * 60 * 1000);

          // Calculate time since last update if less than one hour

          // if(timestampNow - this.state.lastUpdateTimestamp < 1 * 60 * 60 * 1000) {

          let timestampDifference = timestampNow - this.state.lastUpdateTimestamp;


          if (timestampDifference / 1000 / 60 <= 60) {


            if (Math.round(timestampDifference / 1000 / 60) == 1) {
              recentUpdate = 'vor einer Minute';
            } else {
              recentUpdate = `vor ${ Math.round(timestampDifference / 1000 / 60) } Minuten`;
            }

          }

          if (timestampDifference / 1000 <= 60) {
            recentUpdate = 'vor weniger als einer Minute';
          }

          // }

          this.setState({
            loading: false,
            googleData: googleData,
            lastUpdate: recentUpdate
          });


        },
        simpleSheet: true
      }
    )

  }

}

export default GoogleData;



// WEBPACK FOOTER //
// ./src/components/googleData/GoogleData.component.js